import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TaggedSubstationService } from '../../services/tagged-substation.service';
import { NextDataQuality } from '../../models/data-quality.model';

@Component({
  selector: 'lib-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  standalone: false,
})
export class ReviewComponent implements OnInit {
  @Input() assetType: string;
  @Input() assetId: number;
  @Input() fieldAuditDisabled: boolean = false;
  @Output() closeModal = new EventEmitter<NextDataQuality | null>();
  

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private taggedSubstationService: TaggedSubstationService,
  ) {}

  ngOnInit(): void {}

  submitReview() {
    switch (this.assetType) {
      
      case 'Cim Substation': {
        var substationId = this.assetId;
        this.taggedSubstationService.reviewSubstation(substationId).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success(responseData?.message);
              this.handleReturn();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }

      default: {
        break;
      }
    }
  }

  cancel(event: Event) {
    this.closeModal.emit(null);
  }

  handleReturn() {
    var previous = localStorage.getItem('cameFrom');
    if (!previous) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (previous == 'Customer') {
      this.router.navigate(['/customers']);
    } else if (previous == 'Building') {
      this.router.navigate(['/buildings']);
    } else if (previous == 'Pole') {
      this.router.navigate(['/poles']);
    } else if (previous == 'Dt') {
      this.router.navigate(['/transformers']);
    }
  }
}
